module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Peace Love Wellness Mental Health Counseling","short_name":"PLW","description":"Relational, trauma-informed online therapy in New York for adults and couples seeking meaningful change.","start_url":"/","background_color":"#f8f5f0","theme_color":"#e68369","theme_color_in_head":false,"display":"standalone","icon":"src/images/plw-icon.png","legacy":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"631038ed02e6f9a9fa72f9bbbf4a2f19"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
